import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import HeroImage from './HeroImage'

const copy = {
  overline: `Infrastructure`,
  heading: `The Segment Infrastructure`,
  description: `Under the hood of the system that processes 400,000 events every second.`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledHero variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Overline tag="h5" variant="h5">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <HeroImage />
        </HeroRecipe.Contents>
      </StyledHero>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
  overflow-x: hidden;
`

const StyledHero = styled(HeroBase)`
  max-width: 1440px;
`

export default Hero
